"use client";

import { useState, useEffect } from "react";

/**
 * Detecta se o app está rodando como PWA instalado em iOS.
 * Android é excluído intencionalmente — o Chrome já oferece pull-to-refresh nativo.
 */
export function useIsIosPwa(): boolean {
  const [isIosPwa, setIsIosPwa] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);

    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.matchMedia("(display-mode: fullscreen)").matches ||
      window.matchMedia("(display-mode: minimal-ui)").matches ||
      !!(window.navigator as Navigator & { standalone?: boolean }).standalone;

    setIsIosPwa(isIos && isStandalone);
  }, []);

  return isIosPwa;
}

export default useIsIosPwa;
